import StatsTemplate from "./StatsTemplate";

export default function StatsProjects() {
  return <StatsTemplate entityLabel="Projects" entitySingular="Project" entityType="projects" />;
}
